import React from "react";
import { Link } from "react-router-dom";

const ActionLink = ({ to, children, className = "" }) => {
  const classes = ["action-link", className].filter(Boolean).join(" ");

  return (
    <Link to={to} className={classes}>
      <span>{children}</span>
      <span className="action-link__icon" aria-hidden="true">
        →
      </span>
    </Link>
  );
};

export default ActionLink;
